import { useIntl } from 'react-intl'
import './ActivitySummaryChart.scss'
import { LuxButton, Color } from '@lux/wardrobe-lib'
import {
    ActivitySummaryChartData,
    NEW_ACTIVITY_APPROVAL_REDUCER_NAMESPACE,
} from '@/app/redux/reducers/activity-approval'
import { connect } from 'react-redux'
import { Fragment, useEffect, useState } from 'react'
import SummaryChart from '../SummaryChart/SummaryChart'

export interface ActivitySummaryChartProps {
    activitySummaryChartData: Record<string, ActivitySummaryChartData>
}

const ActivitySummaryChart = (props: ActivitySummaryChartProps) => {
    const { activitySummaryChartData } = props

    const componentClass = 'smart-modals-activity-summary-chart'
    const [filterList, setFilterList] = useState([])
    const [chartData, setChartData] = useState({})
    const [chartTotal, setChartTotal] = useState(0)
    const [hasFilterActive, setHasFilterActive] = useState(false)
    const intl = useIntl()

    useEffect(() => {
        let total = 0
        const filters = Object.keys(activitySummaryChartData).map((filter) => {
            total += activitySummaryChartData[filter].stores
            return {
                key: filter,
                label: intl.formatMessage({
                    id: 'modals.new.activity.approval.action.chart.filter.' + filter,
                    defaultMessage: filter,
                }),
                active: false,
            }
        })
        setFilterList(filters)
        setChartTotal(total)
    }, [activitySummaryChartData])

    useEffect(() => {
        // console.log(activitySummaryChartData)
        const filterActive = filterList.filter((filter) => filter.active).length > 0
        setHasFilterActive(filterActive)
        const newData = filterList.map((filter) => ({
            ...activitySummaryChartData[filter.key],
            color:
                !filterActive || filter.active
                    ? activitySummaryChartData[filter.key]?.color
                    : // : chartStatusColors[filter.key],
                      '#d9dbde',
        }))

        setChartData({
            datasets: [
                {
                    data: newData.map((data) => data.percentage),
                    backgroundColor: newData.map((data) => data.color),
                },
            ],
        })
    }, [filterList])

    const onFilter = (filterKey: string) => {
        setFilterList((filterList) =>
            filterList.map((filter) => ({
                ...filter,
                active: filter.key === filterKey ? !filter.active : filter.active,
            }))
        )
    }
    return (
        <div className={componentClass}>
            <h3 className={`${componentClass}__title`}>
                {intl.formatMessage({
                    id: 'modals.new.activity.approval.action.executor.stores',
                    defaultMessage: 'Executor stores',
                })}
            </h3>
            <div className={`${componentClass}__description text`}>
                {intl.formatMessage({
                    id: 'modals.new.activity.approval.action.chart.filter',
                    defaultMessage: 'Select items to filter what you view.',
                })}
            </div>
            <div className={`${componentClass}__filters-container`}>
                {filterList.map((filter) => (
                    <LuxButton
                        key={filter.key}
                        text={filter.label}
                        /*
                        text={intl.formatMessage({
                            id: `modals.search.menu.${filter.label}`,
                            defaultMessage: filter.label,
                        })}
                        */
                        iconRight={filter.active ? 'status-ok' : null}
                        color={filter.active ? Color.BLUE : Color.BG_GREY}
                        onClick={onFilter.bind(null, filter.key)}
                    />
                ))}
            </div>
            <div className={`${componentClass}__chart-container`}>
                <div className={`${componentClass}__chart`}>
                    <SummaryChart chartData={chartData} />
                </div>
                <div className={`${componentClass}__legend`}>
                    <div className={`${componentClass}__legend-header text`}>
                        {intl.formatMessage({
                            id: 'modals.new.activity.approval.action.chart.legend.status',
                            defaultMessage: 'Status',
                        })}
                    </div>
                    <div className={`${componentClass}__legend-header text`}>
                        {intl.formatMessage({
                            id: 'modals.new.activity.approval.action.chart.legend.stores',
                            defaultMessage: 'Stores',
                        })}
                    </div>
                    <div className={`${componentClass}__legend-header text percentage`}>%</div>
                    {filterList.map((filter) => (
                        <Fragment key={filter.key}>
                            <div className={`${componentClass}__legend-body text status`}>
                                <div
                                    className={`${componentClass}__legend-color`}
                                    style={{
                                        backgroundColor:
                                            !hasFilterActive || filter.active
                                                ? activitySummaryChartData[filter.key]?.color
                                                : // : chartStatusColors[filter.key],
                                                  '#d9dbde',
                                    }}></div>
                                <div className="status">
                                    {filter.label}
                                    {/*intl.formatMessage({
                                        id: `modals.search.menu.${filter.label}`,
                                        defaultMessage: filter.label,
                                    })*/}
                                </div>
                            </div>
                            <div className={`${componentClass}__legend-body text`}>
                                {activitySummaryChartData[filter.key]?.stores}
                            </div>
                            <div className={`${componentClass}__legend-body text percentage`}>
                                {activitySummaryChartData[filter.key]?.percentage}
                            </div>
                        </Fragment>
                    ))}
                    <div className={`${componentClass}__legend-footer text total`}>
                        {intl.formatMessage({
                            id: 'modals.new.activity.approval.action.chart.legend.total',
                            defaultMessage: 'Total',
                        })}
                    </div>
                    <div className={`${componentClass}__legend-footer text`}>{chartTotal}</div>
                    <div className={`${componentClass}__legend-footer text percentage`}>100%</div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    activitySummaryChartData:
        state[NEW_ACTIVITY_APPROVAL_REDUCER_NAMESPACE].activitySummaryChartData,
})

const mapDispatchToProps = (dispatch: any) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(ActivitySummaryChart)
